<template>
  <draggable
    :class="{ dropzone: true, 'mt-2': position !== 1 }"
    :disabled="hasItem || isDisabled"
    :group="group"
    :list="list"
  >
    <v-list-item v-if="!hasItem" :class="{ 'dropzone-item': true }">
      <div class="title pr-2 position">{{ position }}</div>
      <v-list-item-avatar class="mr-0"></v-list-item-avatar>
      <v-list-item-content>
        Drag and drop an offer here
      </v-list-item-content>
    </v-list-item>
    <offer-item v-else :offer="offer" :position="position" highlight highlight-draft>
      <v-btn :disabled="isDisabled" icon @click.prevent="onDelete">
        <v-icon>delete_outline</v-icon>
      </v-btn>
    </offer-item>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

import OfferItem from '@/views/offers/components/offer-item'

export default {
  name: 'PromotionDropzone',
  components: {
    draggable,
    OfferItem,
  },
  model: {
    prop: 'list',
  },
  props: {
    group: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  computed: {
    offer() {
      return this.list[0]
    },
    hasItem() {
      return !!this.list.length
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.position)
    },
  },
}
</script>

<style lang="scss" scoped>
.dropzone {
  position: relative;
  min-height: 72px;
}

.dropzone-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px dashed grey !important;
  background: transparent;
  box-shadow: none;
}

.position {
  width: 2em;
}
</style>
